import React, { useState } from 'react';
import forgottenNoorLogo from '../../assets/forgotten-noor-client.png';
import harrisCEO from '../../assets/harris-forgotten-noor.jpeg';
import jabalLogo from '../../assets/jabal-client.png';

const Testimonials = () => {
  const testimonials = [
    {
      text: 'BizDeploy transformed our vision lightning fast into a stunning website.',
      client: 'Forgotten Noor',
      link: 'https://forgottennoor.com.au',
      linkLabel: 'forgottennoor.com.au',
      logo: forgottenNoorLogo,
      imageClass: 'testimonial-image forgotten-noor-brand',
    },
    {
      text: '',
      client: 'Jabal',
      link: 'https://jabal-v7bvt.ondigitalocean.app/',
      linkLabel: 'jabal.com',
      logo: jabalLogo,
      imageClass: 'testimonial-image jabal-brand',
    },
  ];
  const [index, setIndex] = useState(0);
  return (
    <div id="testimonials">
      <h2 className="feature-heading">What Our Clients Say</h2>
      <div className="testimonial-section">
        {/* Carousel logic */}
        <button className="testimonial-arrow left" onClick={() => setIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1))} aria-label="Previous testimonial">&#8592;</button>
        <div className="testimonial-card">
          <div className="testimonial-content">
            <div className="quote-mark">"</div>
            <p className="testimonial-text">{testimonials[index].text}</p>
            <div className="client-info">
              <div className="client-profile">
                <div className="client-details">
                  <p>{testimonials[index].client}</p>
                  <a href={testimonials[index].link} target="_blank" rel="noopener noreferrer" className="client-link">{testimonials[index].linkLabel}</a>
                </div>
              </div>
            </div>
          </div>
          <div className={testimonials[index].imageClass}>
            <img src={testimonials[index].logo} alt={testimonials[index].client} />
          </div>
        </div>
        <button className="testimonial-arrow right" onClick={() => setIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1))} aria-label="Next testimonial">&#8594;</button>
      </div>
    </div>
  );
};

export default Testimonials;